class SplashPage extends HTMLElement {
  connectedCallback() {
    this.check();
  }

  check = () => {
    const days = parseInt(this.dataset.days) || 0;
    const lastClosed = localStorage.getItem('splash_last_closed');
    const now = new Date().getTime();
    if (lastClosed) {
      const elapsedDays = (now - parseInt(lastClosed)) / (1000 * 60 * 60 * 24);
      if (elapsedDays < days) {
        return;
      }
    }
    this.show();
  }

  show = () => {
    console.log('show splash');
    this.classList.remove('hidden');
    this.classList.add('flex');
    localStorage.setItem('splash_last_closed', new Date().getTime().toString());
  }
}
customElements.define('splash-page', SplashPage);

class SplashLink extends HTMLElement {
  imageIndex = 0;

  connectedCallback() {
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.initFade();
  }

  initFade = () => {
    const time = parseInt(this.dataset.timing);
    if(isNaN(time) || time <= 0) return;
    setTimeout(() => {
      const images = this.querySelectorAll('img');
      if(images.length <= 1) return;
      setInterval(() => {
        images[this.imageIndex].classList.remove('shown');
        this.imageIndex = (this.imageIndex + 1) % images.length;
        images[this.imageIndex].classList.add('shown');
      }, time);
    });
  }

  onMouseEnter = () => {
    this.classList.remove('unselected');
    this.classList.add('selected');
    setTimeout(() => {
      const links = document.querySelectorAll('splash-link');
      links.forEach(link => {
        if (link !== this) {
          link.classList.remove('selected');
          link.classList.add('unselected');
        }
      });
    });
  }

  onMouseLeave = () => {
    setTimeout(() => {
      this.classList.remove('selected');
      const links = document.querySelectorAll('splash-link');
      const selectedLinks = Array.from(links).filter(link => link.classList.contains('selected'));
      console.log('selectedLinks', selectedLinks);
      if (selectedLinks.length > 0) {
        return;
      }
      links.forEach(link => {
        if (link !== this) {
          link.classList.remove('selected');
          link.classList.remove('unselected');
        }
      });
    });
  }
}
customElements.define('splash-link', SplashLink);